import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { MapUnavailableText } from './MapUnavailable.styles';

const MapUnavailable: FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  return <MapUnavailableText>{t('RETURN_MAP_UNAVAILABLE')}</MapUnavailableText>;
};

export { MapUnavailable };
